export default __webpack_public_path__ + "static/media/AvatarKids-20.2e16fbfb.png";